import { Loading } from 'components/loading/Loading';
import React from 'react';
import styles from './index.module.scss';

const DeleteAction = ({ onClick, loading }: { onClick: () => void; loading: boolean }) => {
  return (
    <div className={styles['delete-action']}>
      {!loading ? (
        <i
          onClick={onClick}
          className='fa fa-trash-o'
        />
      ): (
        <Loading type={'mini'} />
      )
      }
    </div>
  );
};

export default DeleteAction;
